import { useEffect, useState } from "react";
import { buscarHistoricoInteracoes } from "../services/rastreamento.service";

const useHistoricoInteracoes = (pacienteId) => {
	const [historico, setHistorico] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		const carregarHistorico = async () => {
			if (!pacienteId) {
				setHistorico([]);
				return;
			}

			setLoading(true);
			setError(null);

			try {
				const response = await buscarHistoricoInteracoes(pacienteId);
				setHistorico(response.data || []);
			} catch (err) {
				console.error("Erro ao buscar histórico:", err);
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		carregarHistorico();
	}, [pacienteId]);

	return {
		historico,
		setHistorico,
		loading,
		error,
	};
};

export default useHistoricoInteracoes;
